module.exports = __webpack_public_path__ + "static/media/pdf-download.8da9d8de.svg";